import React, { useRef, useState } from 'react';
import ScheduledMessageFormPopup from './ScheduledMessageFormPopup';
import { useChatPopupStore, useChatStore } from '@store/chat';
import { CHAT_ROOM_REM_WIDTH } from 'constants/chat';
import { deleteScheduledMessage, getScheduledMessageList } from '@apis/api/chat';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import Dialog from '@components/common/modal/Dialog';
import ScheduledMessageListPopup from './ScheduledMessageListPopup';
import { useForm } from 'react-hook-form';
import { ScheduledMessageFormKey } from '@asset/enum/chatEnum';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const ScheduledMessageSection = ({
  isOpenScheduledMessagePopup,
  isOpenScheduledMessageListPopup,
  isTablet,
  setIsOpenScheduledMessagePopup,
  setIsOpenScheduledMessageListPopup,
  handleDragPopup
}) => {
  const {
    chatPopupRef
  } = useChatPopupStore();
  const {
    selectedChannel
  } = useChatStore();
  const scheduleMessageFormPopupRef = useRef(null);
  const scheduleMessageListPopupRef = useRef(null);
  const scheduledMessageForm = useForm({
    mode: 'onChange'
  });
  const [formId, setFormId] = useState(null);
  const [files, setFiles] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [scheduledMessageToDelete, setScheduledMessageToDelete] = useState(null);
  const [openCancelScheduledMessageModal, setOpenCancelScheduledMessageModal] = useState(false);
  const [isOpenResetModal, setIsOpenResetModal] = useState(false);
  const {
    data: scheduledMessagesList,
    refetch: refetchScheduledMessagesList
  } = useQuery(['GET_SCHEDULED_MESSAGES', isOpenScheduledMessageListPopup], async () => (await getScheduledMessageList()).data, {
    initialData: [],
    enabled: isOpenScheduledMessageListPopup
  });
  const handleDeleteScheduledMessage = async () => {
    await deleteScheduledMessage(scheduledMessageToDelete.id).then(() => {
      if (scheduledMessageToDelete.id === selectedMessage?.id) {
        setSelectedMessage(null);
      }
      refetchScheduledMessagesList();
      toast.success('예약 메시지가 삭제되었습니다.');
    }).catch(() => {
      toast.error('예약 메시지 삭제에 실패했습니다.');
    });
    setOpenCancelScheduledMessageModal(false);
    setScheduledMessageToDelete(null);
  };
  const handleDragScheduledMessageFormPopup = (e, data) => {
    if (scheduleMessageFormPopupRef && scheduleMessageFormPopupRef.current) {
      handleDragPopup(e, data, scheduleMessageFormPopupRef);
    }
  };
  const handleDragScheduledMessageListPopup = (e, data) => {
    if (scheduleMessageListPopupRef && scheduleMessageListPopupRef.current) {
      handleDragPopup(e, data, scheduleMessageListPopupRef);
    }
  };
  const resetForm = () => {
    scheduledMessageForm.reset();
    setSelectedMessage(null);
    setFormId(crypto.randomUUID());
    setFiles([]);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isOpenScheduledMessagePopup && /*#__PURE__*/_jsx(ScheduledMessageFormPopup, {
      popupRef: scheduleMessageFormPopupRef,
      defaultPosition: {
        x: scheduleMessageFormPopupRef?.current ? `${scheduleMessageFormPopupRef?.current?.offsetLeft}px` : chatPopupRef?.current ? `${chatPopupRef?.current?.offsetLeft - CHAT_ROOM_REM_WIDTH * 16 + -10}px` : null,
        y: scheduleMessageFormPopupRef?.current ? `${scheduleMessageFormPopupRef?.current?.offsetTop}px` : chatPopupRef?.current ? `${chatPopupRef?.current?.offsetTop}px` : null
      },
      scheduledMessageForm: scheduledMessageForm,
      selectedMessage: selectedMessage,
      isTablet: isTablet,
      onDrag: handleDragScheduledMessageFormPopup,
      togglePopupVisible: visible => {
        setIsOpenScheduledMessagePopup(visible);
        if (!visible) {
          setSelectedMessage(null);
        }
      },
      openScheduledMessageListPopup: () => {
        setIsOpenScheduledMessageListPopup(true);
      },
      onSuccessRegisterScheduledMessage: () => {
        if (isOpenScheduledMessageListPopup) {
          refetchScheduledMessagesList();
        }
        setSelectedMessage(null);
        setFormId(crypto.randomUUID());
      },
      onDeleteScheduledMessage: message => {
        setScheduledMessageToDelete(message);
        setOpenCancelScheduledMessageModal(true);
      },
      files: files,
      setFiles: setFiles
    }, formId), isOpenScheduledMessageListPopup && /*#__PURE__*/_jsx(ScheduledMessageListPopup, {
      popupRef: scheduleMessageListPopupRef,
      defaultPosition: {
        x: scheduleMessageListPopupRef?.current ? `${scheduleMessageListPopupRef?.current?.offsetLeft}px` : scheduleMessageFormPopupRef ? `${scheduleMessageFormPopupRef?.current?.offsetLeft - CHAT_ROOM_REM_WIDTH * 16 + -10}px` : null,
        y: scheduleMessageListPopupRef?.current ? `${scheduleMessageListPopupRef?.current?.offsetTop}px` : scheduleMessageFormPopupRef ? `${scheduleMessageFormPopupRef?.current?.offsetTop}px` : null
      },
      isTablet: isTablet,
      messagesList: scheduledMessagesList,
      handleDrag: handleDragScheduledMessageListPopup,
      onSelectMessage: message => {
        if (!isOpenScheduledMessagePopup) {
          setIsOpenScheduledMessagePopup(true);
        }
        setSelectedMessage(message);
        setFormId(message.id);
      },
      onDeleteMessage: message => {
        setScheduledMessageToDelete(message);
        setOpenCancelScheduledMessageModal(true);
      },
      onClosePopup: () => setIsOpenScheduledMessageListPopup(false),
      onClickResetMessageFormButton: () => {
        if (!isOpenScheduledMessagePopup) {
          setIsOpenScheduledMessagePopup(true);
          return;
        }
        const formValues = Object.fromEntries(Object.entries(scheduledMessageForm.getValues()).filter(([key]) => key !== ScheduledMessageFormKey.RECIPIENT));
        const hasContent = Object.values(formValues).some(value => value !== undefined && value !== null && value !== '');
        const hasFiles = files.length > 0;
        const isRecipientSameAsOpenedChannel = scheduledMessageForm.getValues(ScheduledMessageFormKey.RECIPIENT)?.channelUrl === selectedChannel?.url;
        if (hasContent || hasFiles || !isRecipientSameAsOpenedChannel) {
          setIsOpenResetModal(true);
        }
      }
    }), openCancelScheduledMessageModal && /*#__PURE__*/_jsx(Dialog, {
      title: '예약 메시지 삭제',
      content: ['예약 메시지를 삭제하시겠습니까?'],
      buttons: [{
        variant: 'Outline',
        text: '취소',
        onClick: () => setOpenCancelScheduledMessageModal(false)
      }, {
        variant: 'Destructive',
        text: '삭제하기',
        onClick: () => handleDeleteScheduledMessage()
      }]
    }), isOpenResetModal && /*#__PURE__*/_jsx(Dialog, {
      title: '새로 예약하기',
      content: ['작성중인 내용을 삭제하고', '새로운 예약 메시지를 작성합니다.'],
      buttons: [{
        variant: 'Outline',
        text: '취소',
        onClick: () => setIsOpenResetModal(false)
      }, {
        variant: 'Default',
        text: '확인',
        onClick: () => {
          setIsOpenResetModal(false);
          resetForm();
        }
      }]
    })]
  });
};
export default ScheduledMessageSection;